export default "__VITE_ASSET__DbNN5zLy__"